"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledTheming = _interopRequireDefault(require("styled-theming"));

var _DismissIcon = _interopRequireDefault(require("./DismissIcon"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _VisuallyHidden = _interopRequireDefault(require("../VisuallyHidden"));

var _Constant = require("../Constant");

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  background-color: initial;\n  border: 1px solid transparent; // Consistent sizing on focus\n  border-radius: 2px;\n  cursor: pointer;\n  outline: none;\n  color: ", ";\n\n  /* Focus styles are on keyboard focus */\n  &[data-focus-visible-added]:focus {\n    ", "\n    /* Visible outline for high contrast mode */\n    outline: 2px solid transparent;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

/**
 * box-shadow is used because the focus outline follows the border-radius curve and is placed outside of the button.
 */
var focusStyles = (0, _styledTheming.default)('mode', {
  caliber: "box-shadow: 0 0 0 4px ".concat(_Constant.Color.CALIBER_PASTEL_BLUE, ";"),
  homepoint: "box-shadow: 0 0 0 4px ".concat(_Constant.Color.HOMEPOINT_LIGHT_BLUE, ";"),
  figure: "box-shadow: 0 0 0 4px ".concat(_Constant.Color.FOCUS_B, ";"),
  pella: "box-shadow: 0 0 0 4px ".concat(_Constant.Color.FOCUS_B, ";"),
  petersendean: "box-shadow: 0 0 0 4px ".concat(_Constant.Color.FOCUS_B, ";")
});

var Button = _styledComponents.default.button(_templateObject(), _Constant.Color.BLACK_SOUL, focusStyles);
/**
 * `React.forwardedAs` isn't used here because the `Modal` component does not need to pass a `ref`.
 */


var DismissButton = function DismissButton(_ref) {
  var height = _ref.height,
      text = _ref.text,
      width = _ref.width,
      forwardRef = _ref.forwardRef,
      props = (0, _objectWithoutProperties2.default)(_ref, ["height", "text", "width", "forwardRef"]);
  return /*#__PURE__*/_react.default.createElement(Button, (0, _extends2.default)({
    type: "button"
  }, props, {
    ref: forwardRef
  }), /*#__PURE__*/_react.default.createElement(_VisuallyHidden.default, null, text), /*#__PURE__*/_react.default.createElement(_DismissIcon.default, {
    height: height,
    width: width
  }));
};

DismissButton.propTypes = {
  /** Ref that is forwarded when focus needs to be managed for this button.  */
  forwardRef: _propTypes.default.object,

  /** Height of the SVG element. If null, default is auto.  */
  height: _propTypes.default.string,

  /** Visually hidden button text added for assistive technology users  */
  text: _propTypes.default.string,

  /** Width of the SVG element. If null, default is auto.  */
  width: _propTypes.default.string
};
DismissButton.defaultProps = {
  forwardRef: null,
  height: null,
  text: 'Close',
  width: null
};
var _default = DismissButton;
exports.default = _default;